import Config from '../utils/Config.js';

export default class OrientationHandler extends Phaser.Group {

    constructor(game)
    {
        super(game);

        this.onHide = new Phaser.Signal();

        const bg = this.bg = new Phaser.Graphics(game, 0, 0);
        bg.inputEnabled = true;

        const icon = this.icon = new Phaser.Image(game, 0, 0, 'turn-to');
        icon.anchor.set(0.5);
    }

    get isShown()
    {
        return !!this._isShown;
    }

    show()
    {
        if (this.isShown)
        {
            return;
        }

        const w = Config.GAME_WIDTH;
        const h = Config.GAME_HEIGHT;

        window.ioc = this.icon;

        const game = this.game;

        const bg = this.bg;
        bg.clear();
        bg.beginFill(0x190000);
        bg.drawRect(0, 0, w, h);
        bg.endFill();
        this.addChild(bg);

        const icon = this.icon;
        icon.position.set(w >> 1, h >> 1);
        this.addChild(icon);
        game.world.addChildAt(this, game.world.children.length - 1);

        this._isShown = true;

        this.game.game.paused = true;
    }

    hide()
    {
        if (!this.isShown)
        {
            return;
        }

        this.removeChildren();
        this.onHide.dispatch();

        this._isShown = false;

        this.game.game.paused = false;
    }
}